import { gql } from '@apollo/client';
import { CART_SCHEMA } from './cart.api';

export const CO_CS_CART_SCHEMA = `
    accountId
    acquisitionType
    reference
    agreedTermsAndConditions
    brand
    channel
    channelGroup
    creditScore
    customerType
    offerType
    status
    uuid
    numberAdditionalAllowedOffers
    {
      number
      serviceGroup
    }
    additionalAllowedOffers
    {
      number
      serviceGroup
    }
    offers
    {
      activationAt
      applyDeposit
      depositAmountVatExcluded
      depositTerm
      directoryPreference
      id
      installationAddressId
      parentOfferId
      parentSubscriptionId
      simCard
      {
        msisdn
      }
      portInInfo
      {
        msisdn
        portInReference
        portStartDateTime
      }
      appointment
      {
        type
      }
      prequal
      {
        prequalId
      }
      baseOffer
      {
        description
        portIn
        portInType
        catalogTariffPlanCode
        catalogCode
        simOnly
        serviceGroup
        amountVatIncluded
        {
          discountedOneOffAmount
          discountedUpFrontAmount
          oneOffAmount
          upFrontAmount
          recurringAmount
          {
            discountedAmount
            discountOccurrence
            discountFrequency
            amount
          }
        }              
      }       
    }
    `;

const QUERIES = {
  GET_HANDSETS: gql`
    query getHandsets(
      $reference: String
      $cartOfferID: Int
      $portIn: Boolean
      $accountId: Int
      $cartType: CartType
      $channel: ChannelType
      $offerType: OfferTypeEnum
      $email: String
      $offerCode: String
    ) {
      getHandsets(
        reference: $reference
        cartOfferID: $cartOfferID
        portIn: $portIn
        accountId: $accountId
        cartType: $cartType
        channel: $channel
        offerType: $offerType
        email: $email
        offerCode: $offerCode
      ) {
        reference
        cartOfferID
        handsets {
          sortOrder
          stockLevel
          outOfStock
          image
          imageAltText
          manufacturer
          model
          price
          slug
          flash {
            description
            color
          }
        }
        manufacturers {
          manufacturer
          logo
          logoAltText
        }
      }
    }
  `,
  GET_HANDSET: gql`
    query getHandset(
      $reference: String!
      $cartOfferID: Int!
      $equipmentName: String!
      $cartType: CartType
    ) {
      getHandset(
        reference: $reference
        cartOfferID: $cartOfferID
        equipmentName: $equipmentName
        cartType: $cartType
      ) {
        reference
        cartOfferID
        handset {
          manufacturer
          model
          description
          variants {
            code
            color
            colorCode
            simCardTypes
            images {
              path
              altText
            }
            model
            manufacturer
            price
            networkCompatibility
            capacity
            stockLevel
            addOns {
              code
              description
              offerType
              serviceGroup
              image {
                path
                altText
              }
              mobileImage {
                path
                altText
              }
              charges {
                code
                frequency
                name
                price
              }
              displayName
              details
              orderIndex
            }
          }
          specifications {
            value
            logo {
              path
              altText
            }
            sortOrder
          }
        }
      }
    }
  `,
};
const MUTATION = {
  ADD_HANDSET: gql`
    mutation addHandset(
      $prospectUuid: String!
      $offerId: Int!
      $imei: String
      $catalogCode: String!
      $equipments: [Int]
      $portIn: Boolean
    ) {
      addMobileHandset(
        prospectUuid: $prospectUuid
        offerId: $offerId
        imei: $imei
        catalogCode: $catalogCode
        equipments: $equipments
        portIn: $portIn
        
      ) {
        reference
        ${CART_SCHEMA}
      }
    }
  `,
  REMOVE_HANDSET: gql`
    mutation removeEquipment(
      $prospectUuid: String!
      $offerId: Int!
      $equipmentId: Int!
      $cartType: CartType!
    ) {
      removeEquipment(
        prospectUuid: $prospectUuid
        offerId: $offerId
        equipmentId: $equipmentId
        cartType: $cartType
      ) {
        reference
        ${CART_SCHEMA}
      }
    }
  `,
  ADD_EQUIPMENT: gql`
  mutation addEquipment(
    $cartType: CartType!
    $reference: String!
    $equipmentId: String
    $offerId: Int
    $imei: String
    $catalogCode: String!
    $equipments: [Int]
    $type: String!  
) {
  addEquipment(
    cartType: $cartType
    reference: $reference
    equipmentId: $equipmentId
    offerId: $offerId
    type: $type
    imei: $imei
    catalogCode: $catalogCode
    equipments: $equipments
  ) {
    ${CO_CS_CART_SCHEMA}
  }
}
`,

  REMOVE_EQUIPMENT: gql`
    mutation removeEquipment(
      $cartType: CartType!
      $reference: String!
      $equipmentId: String!
      $offerId: String
  ) {
    removeEquipment(
      cartType: $cartType
      reference: $reference
      equipmentId: $equipmentId
      offerId: $offerId
    ) {
      ${CO_CS_CART_SCHEMA}
    }
  }
`,
};

export const getHandsets = async ({ graphql, variables = {} }) => {
  const { data } = await graphql.query({
    query: QUERIES.GET_HANDSETS,
    variables,
  });

  return data;
};

// to get Mobile Handset
export const getHandset = async ({ graphql, variables = {} }) => {
  const { data } = await graphql.query({
    query: QUERIES.GET_HANDSET,
    variables,
  });
  return data;
};

// to add Mobile Handset
export const addHandset = async ({ graphql, variables = {} }) => {
  const { data } = await graphql.mutate({
    mutation: MUTATION.ADD_HANDSET,
    variables,
  });
  return data;
};

// to remove mobile handset
export const removeHandset = async ({
  graphql,
  variables = { offerId: null, prospectUuid: '', equipmentId: null },
}) => {
  const { data } = await graphql.mutate({
    mutation: MUTATION.REMOVE_HANDSET,
    variables,
  });
  return data;
};

// to add handset( CROSS_SELL or CHANGE_OFFER Journey)
export const addEquipment = async ({ graphql, variables = {} }) => {
  const { data } = await graphql.mutate({
    mutation: MUTATION.ADD_EQUIPMENT,
    variables,
  });
  return data;
};

// to remove handset( CROSS_SELL or CHANGE_OFFER Journey)
export const removeEquipment = async ({ graphql, variables = {} }) => {
  console.log('variables', variables);
  const { data } = await graphql.mutate({
    mutation: MUTATION.REMOVE_EQUIPMENT,
    variables,
  });
  return data;
};
